<template>
  <v-dialog
    v-model="isOpen"
		fullscreen
    scrollable
		@keydown="handleKeydown"
  >
    <v-card class="mlb-overlay pa-0">
    <!-- <div v-if="isOpen" @keydown="handleKeydown"> -->
			<div class="d-flex align-center justify-space-between fm-document-header" style="width: 100%;">
				<img :src="require('@/assets/Svg/logoWhite.svg')" style="max-width: 110px; width: 100%;"/>
        <div v-if="!isMobile" class="d-flex align-center fm-document-header-title">
          <v-icon class="mr-3" color="white">{{ currentFileIcon }}</v-icon>
          <div class="font-weight-medium text-truncate">{{ currentFileName }}</div>
				</div>
        <div class="fm-document-header-primary">
          <div class="fm-document-header-primary-download">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  @click="downloadCurrentItem"
                  color="white"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-download</v-icon>
                </v-btn>
              </template>
              <span>Descargar archivo</span>
            </v-tooltip>
          </div>
          <v-btn v-if="!hideMinimize" icon small @click="$emit('minimize-file', currentItem.item)" class="ml-1 fm-document-header-primary-minimize" color="white">
            <v-icon>mdi-minus</v-icon>
          </v-btn>
          <v-btn icon small @click="$emit('close')" class="ml-1 fm-document-header-primary-close fm-document-header-close" color="white">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <div class="d-flex align-center fm-document-header-actions" style="gap: 8px;">
          <div class="fm-document-header-secondary">
          <div class="mlb-zoom-controls" v-if="isImage(currentItem)">
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="white"
                  :disabled="zoomLevel >= maxZoom"
                  aria-label="Zoom in"
                  @click.stop="zoomIn"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-plus</v-icon>
                </v-btn>
              </template>
              <span>Acercar</span>
            </v-tooltip>
            <span class="mlb-zoom-value">{{ Math.round(zoomLevel * 100) }}%</span>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="white"
                  :disabled="zoomLevel <= minZoom"
                  aria-label="Zoom out"
                  @click.stop="zoomOut"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-minus</v-icon>
                </v-btn>
              </template>
              <span>Alejar</span>
            </v-tooltip>
            <v-tooltip top>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  icon
                  small
                  color="white"
                  :disabled="zoomLevel === minZoom && panX === 0 && panY === 0"
                  aria-label="Reset zoom"
                  @click.stop="resetView"
                  v-bind="attrs"
                  v-on="on"
                >
                  <v-icon>mdi-image-filter-center-focus</v-icon>
                </v-btn>
              </template>
              <span>Restablecer zoom</span>
            </v-tooltip>
          </div>
					<v-chip small outlined color="white" label v-if="!isMobile">{{ currentFileInfo }}</v-chip>
					<v-tooltip top>
						<template v-slot:activator="{ on, attrs }">
							<v-btn
								icon
								small
								@click="associationsOpen = !associationsOpen"
								color="white"
								v-bind="attrs"
								v-on="on"
							>
								<v-icon>mdi-link-variant</v-icon>
							</v-btn>
						</template>
						<span>Asociaciones</span>
					</v-tooltip>
					<div v-if="openMorphableText">
						<v-tooltip top>
							<template v-slot:activator="{ on, attrs }">
								<v-btn
									icon
									small
									color="white"
									@click="$emit('open-morphable', currentItem.item)"
									v-bind="attrs"
									v-on="on"
								>
									<v-icon>{{ openMorphableIcon }}</v-icon>
								</v-btn>
							</template>
							<span>{{ openMorphableText }}</span>
						</v-tooltip>
					</div>
					<v-btn icon small @click="showThumbs = !showThumbs" class="ml-1" color="white">
						<v-icon>mdi-view-grid</v-icon>
					</v-btn>
          </div>
				</div>
			</div>

      <!-- Counter -->
      <!-- <div class="mlb-counter">
        <span>{{ currentIndex + 1 }}</span>
        <span class="mlb-counter-sep">/</span>
        <span>{{ items.length }}</span>
      </div> -->

      <!-- Arrow left -->
      <button
        class="mlb-btn mlb-arrow mlb-arrow--left"
        @click="prev"
        :disabled="items.length <= 1"
        aria-label="Anterior"
        style="position: absolute; left: 16px; top: 50%; transform: translateY(-50%); z-index: 10; background: rgba(0,0,0,0.45);"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15 18 9 12 15 6"/>
        </svg>
      </button>

      <!-- Media wrapper (drag area) -->
      <div
      ref="stage"
        class="mlb-stage"
        @mousedown="startDrag"
        @mousemove="onDrag"
        @mouseup="endDrag"
        @mouseleave="cancelDrag"
      @wheel.prevent="handleWheel"
      @touchstart="startTouch"
      @touchmove="onTouch"
        @touchend="endTouch"
      @touchcancel="endTouch"
      >
        <transition :name="transitionName" mode="out-in">
          <div class="mlb-media-wrap" :key="currentIndex">
            <!-- Image -->
            <img
              v-if="isImage(currentItem)"
              :src="currentItem.src"
              class="mlb-media mlb-img"
              :alt="currentItem.alt || ''"
              :style="imageTransformStyle"
              ref="mediaImage"
              draggable="false"
              @load="onMediaLoad"
            />
            <!-- Video -->
            <video
              v-else-if="isVideo(currentItem)"
              :src="currentItem.src"
              class="mlb-media mlb-video"
              :autoplay="currentItem.autoplay !== false"
              controls
              playsinline
              :loop="currentItem.loop || false"
              @loadeddata="onMediaLoad"
            />
            <!-- Fallback -->
            <div v-else class="mlb-unsupported">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5">
                <circle cx="12" cy="12" r="10"/>
                <line x1="12" y1="8" x2="12" y2="12"/>
                <line x1="12" y1="16" x2="12.01" y2="16"/>
              </svg>
              <p>Formato no soportado</p>
            </div>
          </div>
        </transition>

        <!-- Drag hint overlay (shown briefly) -->
        <div class="mlb-drag-hint" v-if="showDragHint">
          <span>← Arrastra para navegar →</span>
        </div>
      </div>

      <!-- Arrow right -->
      <button
        class="mlb-btn mlb-arrow mlb-arrow--right"
        @click="next"
        :disabled="items.length <= 1"
        aria-label="Siguiente"
        style="position: absolute; right: 16px; top: 50%; transform: translateY(-50%); z-index: 10; background: rgba(0,0,0,0.45);"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9 18 15 12 9 6"/>
        </svg>
      </button>

      <!-- Thumbnail strip -->
      <div class="mlb-thumbs" v-if="items.length > 1 && showThumbs">
        <button
          v-for="(item, i) in items"
          :key="i"
          class="mlb-thumb"
          :class="{ 'mlb-thumb--active': i === currentIndex }"
          @click="goTo(i)"
          :aria-label="'Ir a ' + (i + 1)"
        >
          <img v-if="isImage(item)" :src="item.src" draggable="false" />
          <div v-else class="mlb-thumb-video-icon">
            <svg viewBox="0 0 24 24" fill="currentColor">
              <polygon points="5 3 19 12 5 21 5 3"/>
            </svg>
          </div>
        </button>
      </div>

			<AssociationsListModal v-model="associationsOpen" :file-id="currentFileId" />
    </v-card>
  </v-dialog>
</template>

<script>
import AssociationsListModal from '@/components/Globals/Helpers/AssociationsListModal'

export default {
  name: 'MediaViewer',

	components: { AssociationsListModal },

  props: {
    // Each item: { src: String, autoplay?: Boolean, loop?: Boolean, alt?: String }
    items: {
      type: Array,
      default: function () { return [] }
    },
    index: {
      type: Number,
      default: null
    },
		hideOpenMorphable: {
			type: Boolean,
			default: false
		},
		hideMinimize: {
			type: Boolean,
			default: false
		}
  },

  data: function () {
    return {
      currentIndex: 0,
      transitionName: 'slide-left',
      dragStartX: null,
      isDragging: false,
      dragThreshold: 60,
      touchStartX: null,
      touchStartY: null,
      touchLastX: null,
      touchLastY: null,
      touchStartDistance: null,
      touchLastCenter: null,
      pinchStartZoom: 1,
      touchMode: null,
      touchDidPinch: false,
      zoomLevel: 1,
      minZoom: 1,
      maxZoom: 4,
      zoomStep: 0.25,
      panX: 0,
      panY: 0,
      dragStartY: null,
      dragLastX: null,
      dragLastY: null,
      showDragHint: false,
      hintTimer: null,
			showThumbs: false,
			associationsOpen: false
    }
  },

  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.mobile
    },
    isOpen: function () {
      return this.index !== null && this.index !== undefined
    },
    currentItem: function () {
      return this.items[this.currentIndex] || {}
    },
    imageTransformStyle: function () {
      return {
        transform: `translate3d(${this.panX}px, ${this.panY}px, 0) scale(${this.zoomLevel})`,
        transformOrigin: 'center center',
        transition: this.isDragging ? 'none' : 'transform 160ms ease'
      }
    },
		currentFileId() {
			return (this.currentItem && this.currentItem.item && this.currentItem.item.id) ||
				(this.currentItem && this.currentItem.id) || null
		},
		currentFileName(){
			return this.currentItem.name || 'Archivo multimedia'
		},
    currentFileIcon() {
      const ext = this.currentItem?.ext?.toLowerCase()
      const iconMap = {
        'pdf': 'mdi-file-pdf-box',
        'doc': 'mdi-file-word',
        'docx': 'mdi-file-word',
        'xls': 'mdi-file-excel',
        'xlsx': 'mdi-file-excel',
        'ppt': 'mdi-file-powerpoint',
        'pptx': 'mdi-file-powerpoint'
      }
      return iconMap[ext] || 'mdi-file-document'
    },
    currentFileInfo() {
      const ext = this.currentItem?.ext?.toUpperCase() || 'ARCHIVO'
      const size = this.currentFileSize
      return `${ext}${size ? ` • ${size}` : ''}`
    },
    currentFileSize() {
      const size = this.currentItem?.size
      if (!size) return null
      if (size < 1024) return `${size} B`
      if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`
      return `${(size / (1024 * 1024)).toFixed(2)} MB`
    },
		openMorphableText(){
			if(!this.currentItem || !this.currentItem.item || !this.currentItem.item.morphable_type || this.hideOpenMorphable) return null
			if(this.currentItem.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.currentItem.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'Abrir Tarea Asociada'
			}
			else if(this.currentItem.item.morphable_type === 'App\\Models\\Rdi' || this.currentItem.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'Abrir RDI Asociada'
			}
			else if(this.currentItem.item.morphable_type === 'App\\Models\\Additional' || this.currentItem.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.currentItem.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'Abrir Adicional Asociado'
			}
			return null
		},
		openMorphableIcon(){
			if(!this.currentItem || !this.currentItem.item || !this.currentItem.item.morphable_type) return null
			if(this.currentItem.item.morphable_type === 'App\\Models\\TasksRestrictions' || this.currentItem.item.morphable_type === 'App\\Models\\TasksRestrictionsInteractions'){
				return 'mdi-clipboard-text-outline'
			}
			else if(this.currentItem.item.morphable_type === 'App\\Models\\Rdi' || this.currentItem.item.morphable_type === 'App\\Models\\RdiInteractions'){
				return 'mdi-file-document-multiple-outline'
			}
			else if(this.currentItem.item.morphable_type === 'App\\Models\\Additional' || this.currentItem.item.morphable_type === 'App\\Models\\AdditionalRevision' || this.currentItem.item.morphable_type === 'App\\Models\\AdditionalObservation'){
				return 'mdi-notebook-plus-outline'
			}
			return null
		}
  },

  watch: {
    index: function (val) {
      this.associationsOpen = false
      if (val !== null && val !== undefined) {
        this.currentIndex = val
				this.resetView()
        var self = this
        this.$nextTick(function () {
          if (self.$refs.overlay) self.$refs.overlay.focus()
          self.triggerHint()
        })
      }
    }
  },

	mounted() {
		if (this.index !== null && this.index !== undefined) {
			this.currentIndex = this.index
      this.resetView()
			var self = this
			this.$nextTick(function () {
				if (self.$refs.overlay) self.$refs.overlay.focus()
				self.triggerHint()
			})
		}
	},
  methods: {
    onMediaLoad() {
      if (this.currentItem?.item) {
        this.$emit('load', { item: this.currentItem.item, viewer: 'media' })
      }
    },

    downloadCurrentItem() {
      if (!this.currentItem?.downloadable_url) return
      this.$emit('download', { item: this.currentItem.item, viewer: 'media' })
      window.open(this.currentItem.downloadable_url, '_blank')
    },

    isImage: function (item) {
      if (!item || !item.src) return false
      return /\.(jpe?g|png|gif|webp|avif|svg|bmp)(\?.*)?$/i.test(item.src) ||
        /^data:image\//i.test(item.src)
    },

    isVideo: function (item) {
      if (!item || !item.src) return false
      return /\.(mp4|webm|ogg|ogv|mov|m4v)(\?.*)?$/i.test(item.src) ||
        /^data:video\//i.test(item.src)
    },

		openInNewTab() {
			if (this.item) {
				const width = window.outerWidth;
				const height = window.outerHeight;
				const left = window.screenX;
				const top = window.screenY;
				const url = 'media-viewer?item_id=' + this.item.id;
				window.open(
					url,
					'_blank',
					`width=${width},height=${height},left=${left},top=${top},noopener,noreferrer`
				);
				this.closeDialog();
			}
		},

    goTo: function (i) {
      if (i === this.currentIndex) return
      this.transitionName = i > this.currentIndex ? 'slide-left' : 'slide-right'
			this.resetView()
      this.currentIndex = i
      this.$emit('onChange', i)
    },

    next: function () {
			if (!this.items.length) return
      var next = (this.currentIndex + 1) % this.items.length
      this.transitionName = 'slide-left'
			this.resetView()
      this.currentIndex = next
      this.$emit('onChange', next)
    },

    prev: function () {
			if (!this.items.length) return
      var prev = (this.currentIndex - 1 + this.items.length) % this.items.length
      this.transitionName = 'slide-right'
			this.resetView()
      this.currentIndex = prev
      this.$emit('onChange', prev)
    },

    handleKeydown: function (e) {
      if (e.key === 'ArrowRight') this.next()
      else if (e.key === 'ArrowLeft') this.prev()
      else if (e.key === 'Escape') this.$emit('close')
    },

    startDrag: function (e) {
      if (e.button !== undefined && e.button !== 0) return
      this.dragStartX = e.clientX
      this.dragStartY = e.clientY
      this.dragLastX = e.clientX
      this.dragLastY = e.clientY
      this.isDragging = true
    },
    onDrag: function (e) {
      if (!this.isDragging) return
      if (this.isImage(this.currentItem) && this.zoomLevel > this.minZoom) {
        this.panBy(e.clientX - this.dragLastX, e.clientY - this.dragLastY)
        this.dragLastX = e.clientX
        this.dragLastY = e.clientY
      }
    },
    endDrag: function (e) {
      if (!this.isDragging || this.dragStartX === null) return
      var dx = e.clientX - this.dragStartX
      if (this.isImage(this.currentItem) && this.zoomLevel > this.minZoom) {
        this.onDrag(e)
      } else if (Math.abs(dx) > this.dragThreshold) {
        dx < 0 ? this.next() : this.prev()
      }
      this.clearDrag()
    },
    cancelDrag: function () {
      this.clearDrag()
    },

    startTouch: function (e) {
      if (!e.touches.length) return
      if (e.touches.length >= 2) {
        this.beginPinch(e.touches)
        return
      }
      var touch = e.touches[0]
      this.touchStartX = touch.clientX
      this.touchStartY = touch.clientY
      this.touchLastX = touch.clientX
      this.touchLastY = touch.clientY
      this.touchMode = this.zoomLevel > this.minZoom ? 'pan' : 'swipe'
      this.touchDidPinch = false
      this.isDragging = true
    },
    onTouch: function (e) {
      if (e.touches.length >= 2) {
        e.preventDefault()
        if (this.touchStartDistance === null) this.beginPinch(e.touches)
        var center = this.getTouchCenter(e.touches)
        var distance = this.getTouchDistance(e.touches)
        this.setZoom(this.pinchStartZoom * distance / this.touchStartDistance, center)
        if (this.touchLastCenter) {
          this.panBy(center.clientX - this.touchLastCenter.clientX, center.clientY - this.touchLastCenter.clientY)
        }
        this.touchLastCenter = center
        this.touchDidPinch = true
        return
      }
      if (!e.touches.length) return
      var touch = e.touches[0]
      if (this.touchMode === 'pan' && this.zoomLevel > this.minZoom) {
        e.preventDefault()
        this.panBy(touch.clientX - this.touchLastX, touch.clientY - this.touchLastY)
      }
      this.touchLastX = touch.clientX
      this.touchLastY = touch.clientY
    },
    endTouch: function (e) {
      if (e.touches && e.touches.length) {
        if (e.touches.length === 1) {
          this.touchMode = this.zoomLevel > this.minZoom ? 'pan' : 'swipe'
          this.touchLastX = e.touches[0].clientX
          this.touchLastY = e.touches[0].clientY
        }
        return
      }
      if (!e.changedTouches || !e.changedTouches.length) {
        this.clearTouch()
        return
      }
      if (this.touchStartX === null && !this.touchDidPinch) return
      var dx = this.touchStartX === null ? 0 : e.changedTouches[0].clientX - this.touchStartX
      if (this.touchMode === 'swipe' && !this.touchDidPinch && this.zoomLevel === this.minZoom && Math.abs(dx) > this.dragThreshold) {
        dx < 0 ? this.next() : this.prev()
      }
      this.clearTouch()
    },

    handleWheel: function (e) {
      if (!this.isImage(this.currentItem)) return
      var direction = e.deltaY > 0 ? -1 : 1
      this.setZoom(this.zoomLevel + direction * this.zoomStep, e)
    },

    zoomIn: function () {
      this.setZoom(this.zoomLevel + this.zoomStep)
    },

    zoomOut: function () {
      this.setZoom(this.zoomLevel - this.zoomStep)
    },

    setZoom: function (value, point) {
      if (!this.isImage(this.currentItem)) return
      var nextZoom = Math.max(this.minZoom, Math.min(this.maxZoom, value))
      var previousZoom = this.zoomLevel
      if (nextZoom === previousZoom && !point) return
      if (point && previousZoom > 0 && nextZoom !== previousZoom) {
        var rect = this.getStageRect()
        var pointX = point.clientX - rect.left - rect.width / 2
        var pointY = point.clientY - rect.top - rect.height / 2
        var zoomRatio = nextZoom / previousZoom
        this.panX += (pointX - this.panX) * (1 - zoomRatio)
        this.panY += (pointY - this.panY) * (1 - zoomRatio)
      }
      this.zoomLevel = nextZoom
      if (nextZoom === this.minZoom) {
        this.panX = 0
        this.panY = 0
      } else {
        this.clampPan()
      }
    },

    resetView: function () {
      this.zoomLevel = this.minZoom
      this.panX = 0
      this.panY = 0
    },

    panBy: function (x, y) {
      this.panX += x
      this.panY += y
      this.clampPan()
    },

    clampPan: function () {
      var limits = this.getPanLimits()
      this.panX = Math.max(-limits.x, Math.min(limits.x, this.panX))
      this.panY = Math.max(-limits.y, Math.min(limits.y, this.panY))
    },

    getStageRect: function () {
      if (this.$refs.stage && this.$refs.stage.getBoundingClientRect) return this.$refs.stage.getBoundingClientRect()
      return { left: 0, top: 0, width: 0, height: 0 }
    },

    getPanLimits: function () {
      var stage = this.getStageRect()
      var image = this.$refs.mediaImage
      var imageWidth = image && (image.offsetWidth || image.clientWidth)
      var imageHeight = image && (image.offsetHeight || image.clientHeight)
      if (!imageWidth || !imageHeight || !stage.width || !stage.height) return { x: 0, y: 0 }
      return {
        x: Math.max(0, (imageWidth * this.zoomLevel - stage.width) / 2),
        y: Math.max(0, (imageHeight * this.zoomLevel - stage.height) / 2)
      }
    },

    getTouchDistance: function (touches) {
      var dx = touches[1].clientX - touches[0].clientX
      var dy = touches[1].clientY - touches[0].clientY
      return Math.sqrt(dx * dx + dy * dy)
    },

    getTouchCenter: function (touches) {
      return {
        clientX: (touches[0].clientX + touches[1].clientX) / 2,
        clientY: (touches[0].clientY + touches[1].clientY) / 2
      }
    },

    beginPinch: function (touches) {
      this.touchStartDistance = this.getTouchDistance(touches)
      this.pinchStartZoom = this.zoomLevel
      this.touchLastCenter = this.getTouchCenter(touches)
      this.touchMode = 'pinch'
      this.touchDidPinch = true
      this.isDragging = true
    },

    clearDrag: function () {
      this.isDragging = false
      this.dragStartX = null
      this.dragStartY = null
      this.dragLastX = null
      this.dragLastY = null
    },

    clearTouch: function () {
      this.touchStartX = null
      this.touchStartY = null
      this.touchLastX = null
      this.touchLastY = null
      this.touchStartDistance = null
      this.touchLastCenter = null
      this.touchMode = null
      this.touchDidPinch = false
      this.isDragging = false
    },

    triggerHint: function () {
      if (this.items.length <= 1) return
      this.showDragHint = true
      clearTimeout(this.hintTimer)
      var self = this
      this.hintTimer = setTimeout(function () { self.showDragHint = false }, 2000)
    }
  },

  // Vue 2 uses beforeDestroy, not beforeUnmount
  beforeDestroy: function () {
    clearTimeout(this.hintTimer)
  }
}
</script>

<style scoped>
/* ─── Variables ─────────────────────────────────────────────────── */
.mlb-overlay {
  --mlb-bg: rgba(5, 5, 8, 0.96);
  --mlb-accent: #e8d5b0;
  --mlb-text: #f0ece4;
  --mlb-muted: rgba(240, 236, 228, 0.4);
  --mlb-btn-bg: rgba(240, 236, 228, 0.08);
  --mlb-btn-hover: rgba(232, 213, 176, 0.18);
  --mlb-radius: 4px;
  --mlb-thumb-size: 56px;
  --mlb-arrow-size: 52px;
  --mlb-z: 9999;
  --mlb-transition: 220ms cubic-bezier(0.4, 0, 0.2, 1);
}

/* ─── Overlay ───────────────────────────────────────────────────── */
.mlb-overlay {
  display: flex;
  flex-direction: column;
  height: 100%;
	min-height: 0;
	overflow: hidden;
	background-color: rgba(0,0,0,0.92);
}

/* ─── Close ─────────────────────────────────────────────────────── */
.mlb-close {
  grid-area: close;
  justify-self: start;
  align-self: start;
  margin: 16px;
}

/* ─── Counter ───────────────────────────────────────────────────── */
.mlb-counter {
  grid-area: counter;
  justify-self: end;
  align-self: start;
  margin: 22px 20px 0 0;
  font-size: 13px;
  letter-spacing: 0.12em;
  color: var(--mlb-text);
  display: flex;
  align-items: center;
  gap: 4px;
  user-select: none;
}
.mlb-counter-sep { color: var(--mlb-accent); opacity: 0.6; }

/* ─── Buttons ───────────────────────────────────────────────────── */
.mlb-btn {
  background: var(--mlb-btn-bg);
  border: 1px solid rgba(240, 236, 228, 0.1);
  color: var(--mlb-text);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background var(--mlb-transition), border-color var(--mlb-transition), transform var(--mlb-transition);
  border-radius: var(--mlb-radius);
  backdrop-filter: blur(6px);
}
.mlb-btn:hover:not(:disabled) {
  background: var(--mlb-btn-hover);
  border-color: rgba(232, 213, 176, 0.3);
}
.mlb-btn:active:not(:disabled) { transform: scale(0.93); }
.mlb-btn:disabled { opacity: 0.2; cursor: default; }
.mlb-btn svg { width: 20px; height: 20px; }

.mlb-close {
  width: 38px; height: 38px;
  border-radius: 50%;
}

/* ─── Arrows ────────────────────────────────────────────────────── */
/* Flechas rectangulares */
.mlb-arrow {
  width: 48px;
  height: 72px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.18);
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background 0.2s;
  background: red;
}
/* El posicionamiento ahora es inline en el template para evitar conflictos con el layout flex */

/* ─── Stage ─────────────────────────────────────────────────────── */
.mlb-stage {
  grid-area: stage;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 0;
  min-height: 0;
  height: auto;
  cursor: grab;
  overflow: hidden;
  user-select: none;
  touch-action: none;
}
.mlb-stage:active { cursor: grabbing; }

.mlb-media-wrap {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  padding: 12px;
  box-sizing: border-box;
}

.mlb-media {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
  border-radius: 2px;
  box-shadow: 0 8px 48px rgba(0,0,0,0.6);
}
.mlb-zoom-controls {
  display: flex;
  align-items: center;
  gap: 2px;
}
.mlb-zoom-value {
  min-width: 42px;
  color: var(--mlb-text);
  font-size: 11px;
  text-align: center;
  user-select: none;
}
.mlb-img { display: block; }
.mlb-video { width: 100%; max-height: 100%; background: #000; }

.mlb-unsupported {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  color: var(--mlb-muted);
}
.mlb-unsupported svg { width: 48px; height: 48px; }
.mlb-unsupported p { font-size: 14px; margin: 0; }

/* ─── Drag hint ─────────────────────────────────────────────────── */
.mlb-drag-hint {
  position: absolute;
  bottom: 20px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(0,0,0,0.55);
  border: 1px solid rgba(232, 213, 176, 0.2);
  color: var(--mlb-text);
  font-size: 12px;
  letter-spacing: 0.1em;
  padding: 7px 16px;
  border-radius: 20px;
  pointer-events: none;
  backdrop-filter: blur(8px);
  animation: hintFade 2s ease forwards;
}
@keyframes hintFade {
  0%   { opacity: 0; transform: translateX(-50%) translateY(6px); }
  20%  { opacity: 1; transform: translateX(-50%) translateY(0); }
  75%  { opacity: 1; }
  100% { opacity: 0; }
}

/* ─── Thumbnails ────────────────────────────────────────────────── */
.mlb-thumbs {
  grid-area: thumbs;
  flex: 0 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 14px 16px;
  overflow-x: auto;
  scrollbar-width: none;
}
.mlb-thumbs::-webkit-scrollbar { display: none; }

.mlb-thumb {
  flex-shrink: 0;
  width: var(--mlb-thumb-size);
  height: var(--mlb-thumb-size);
  border-radius: var(--mlb-radius);
  overflow: hidden;
  border: 2px solid transparent;
  cursor: pointer;
  background: rgba(240,236,228,0.06);
  transition: border-color var(--mlb-transition), opacity var(--mlb-transition), transform var(--mlb-transition);
  opacity: 0.45;
  padding: 0;
}
.mlb-thumb img {
  width: 100%; height: 100%;
  object-fit: cover;
  display: block;
}
.mlb-thumb-video-icon {
  width: 100%; height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--mlb-muted);
}
.mlb-thumb-video-icon svg { width: 22px; height: 22px; }

.mlb-thumb--active {
  border-color: var(--mlb-accent);
  opacity: 1;
  transform: scale(1.08);
}
.mlb-thumb:not(.mlb-thumb--active):hover {
  opacity: 0.75;
  transform: scale(1.04);
}

/* ─── Overlay transition ────────────────────────────────────────── */
.lightbox-fade-enter-active,
.lightbox-fade-leave-active {
  transition: opacity 280ms ease;
}
.lightbox-fade-enter-from,
.lightbox-fade-leave-to {
  opacity: 0;
}

/* ─── Slide transitions ─────────────────────────────────────────── */
.slide-left-enter-active,
.slide-left-leave-active,
.slide-right-enter-active,
.slide-right-leave-active {
  transition: transform 260ms cubic-bezier(0.4, 0, 0.2, 1), opacity 260ms ease;
  position: absolute;
}

.slide-left-enter-from  { transform: translateX(50px);  opacity: 0; }
.slide-left-leave-to    { transform: translateX(-50px); opacity: 0; }
.slide-right-enter-from { transform: translateX(-50px); opacity: 0; }
.slide-right-leave-to   { transform: translateX(50px);  opacity: 0; }

.fm-document-header {
  border-bottom: 1px solid #213872;
  padding: 8px 16px !important;
  background: #2D4B95;
	color: white;
}

.fm-document-header .v-toolbar__content {
  padding: 0 !important;
}
</style>